import  { useContext, useState } from "react";
import { Colour, Tsize, View, FontType, Header, UserAudios, Bplay, Hindit, IskconContent} from "../global";
import { IonToolbar, IonLabel, IonButtons, IonButton, IonCard, IonCardContent, IonPage, IonHeader, IonContent } from "@ionic/react";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { ViewAgendaSharp, MenuBookSharp, ArrowBackSharp, MoreVertSharp } from "@mui/icons-material";
import ScrollToTop from "../scroll";
import { motion } from "framer-motion";
import { ViewHeadlineSharp } from "@mui/icons-material";
import { Helmet } from "react-helmet";
import YouTubePlayer from "../music/youtubeplayer";
import Music from "../music/music";

function SBP(props) {
 let { ind } = useParams();
 let arrs = ind.split("_");
 let i2 = Number(arrs[0]);
 let id = Number(arrs[1]);
 let history = useHistory();
 const content = props.SBbook;
 let {  url } = useRouteMatch();
 const [clr, ] = useContext(Colour);
 const [hindit, ] = useContext(Hindit);

 let color,color2,color3,colori,colorh;
 if(clr === "1") {
  color = "#00CBFE";
  color2 = "#04010f";
  color3 = "black"
  colori = "light"
  colorh = "primary"
 }
 if(clr === "2") {
  color = "#FFE34D";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
 }
 if(clr === "3") {
  color = "#FFA500";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
 }
 if(clr === "4") {
  color = "#87CEEB";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
 }
 if(clr === "5") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "warning"
 }
 if(clr === "6") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "tertiary"
 }
 const [tsize, ] = useContext(Tsize);
 const [view, ] = useContext(View);
 let vtm;
 if (view === "2") vtm = false;
 else vtm = true;
 const [vtb, setVtb] = useState(vtm);
 let wwmb;
 if (view === "3") wwmb = true;
 else wwmb = false;
 const [wwm, setWwm] = useState(wwmb);
 const [header, ] = useContext(Header);
 const [anchorEl, setAnchorEl] = useState(null);
 const [font, ] = useContext(FontType);

 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";


 const [iskcon, ] = useContext(IskconContent);
 let vname = content.chap[i2].song[id].vname;
 let vindex;
 if (vname){
  vindex = 0;
  for (let i in iskcon.songs) {
   if (iskcon.songs[i].name === vname) {
    vindex = i;
    break;
   }
  }
 }


 let present3 = -4;
 let index2 = 1;
 let present2 = 0;
 let iarr2 = [];
 let left;

 let fun2 = hindit && content.chap[i2].song[id].hname ? content.chap[i2].song[id].hbody : content.chap[i2].song[id].body;

 while (true) {
  if (present2 === "-1" || present2 === -1) {
   break;
  }

  present2 = fun2.indexOf("Text", fun2.indexOf("Text", present2) + 5);
  iarr2.push(index2.toString());
  index2++;
 }

 let verses = ""
 let translation = ""

 if (!wwm && !vtb) {
  // eslint-disable-next-line
  {iarr2.map((sent, i) => {
    let ind1 = fun2.indexOf("Text", present3 + 4);
    present3 = ind1;
    let ind2 = i < iarr2.length - 1 ? fun2.indexOf("Text", ind1 + 4) : fun2.length;

    let zen = fun2.slice(ind1, ind2);

    let ztext = zen.split(/\r\n|\n/);

    left = false;
       verses +=  `(${i+1})\n`
       translation += `${i+1}) `
       // eslint-disable-next-line
       {ztext.map((vad, i) => {
        if (i === 0) return null;
        if (vad.indexOf(";") !== -1) {
         left = true;
        }   
        if (!left){
          verses += (vad + "\n")
        }
        if (left){
          if (vad.indexOf(";") === -1) translation += (vad + "\n")
        }
       return null
       })}
       return null
   })}
 }



 const [userAudios, ] = useContext(UserAudios)
 const songName = content.chap[i2].song[id].name.slice(3)
 const [, setBplay] = useContext(Bplay);

 let title = hindit && content.chap[i2].song[id].hname ? content.chap[i2].song[id].hname : songName.slice(0, content.chap[i2].song[id].name.indexOf("(SB") - 3)




 function goback() {
  setBplay({ fold: 0, song: 0 });
  if(history.length > 1){
    history.goBack()
  }else{
    history.push(url.slice(0, url.lastIndexOf("/")));
  }
 }

 const toolbar =  <IonToolbar color={colorh}>
 <IonButtons slot="start">
  <IonButton onClick={goback}>
  <ArrowBackSharp style={{ fontSize: 30 }} />
  </IonButton>
 </IonButtons>
 <IonButtons slot="start">
  <IonLabel style={{ fontSize: "16px", fontFamily: `${fon}` }}>
   {title}
  </IonLabel>
 </IonButtons>
 {!wwm ? (
  <>
   {vtb ? (
    <IonButtons slot="end">
     <IonButton
      onClick={() => {
       setVtb(!vtb);
      }}
     >
      <ViewHeadlineSharp />
     </IonButton>
    </IonButtons>
   ) : (
    <IonButtons slot="end">
     <IonButton
      onClick={() => {
       setWwm(!wwm);
      }}
     >
      <ViewAgendaSharp />
     </IonButton>
    </IonButtons>
   )}
  </>
 ) : (
  <IonButtons slot="end">
   <IonButton
    onClick={() => {
     setWwm(!wwm);
     setVtb(!vtb);
    }}
   >
    <MenuBookSharp />
   </IonButton>
  </IonButtons>
 )}

<IonButtons slot="end">
   <IonButton
   style={{marginRight:"7px"}}
    onClick={(e) => {
      setAnchorEl(e.currentTarget);
    }}
   >
    <MoreVertSharp />
   </IonButton>
  </IonButtons>
</IonToolbar>;
 return (
  <IonPage>
  <Helmet>
      <title>{title}</title>
      <meta name="description" content={content.chap[i2].song[id].name.slice(3).slice(0, content.chap[i2].song[id].name.indexOf("(SB") - 3)} />
  </Helmet>
   <ScrollToTop />

   {!(userAudios[songName] && userAudios[songName].type === "youtube") && header==="true" ? <IonHeader className="lhide print-hide">
      {toolbar}
    </IonHeader> : null}
    {(userAudios[songName] && userAudios[songName].type === "youtube") ? <YouTubePlayer
    colorh={colorh}
    userAudios={userAudios}
    name={songName}
     /> : null}
   <IonContent  color={colori} >
   {((userAudios[songName] && userAudios[songName].type === "youtube") || header !== "true") ? <div className="lhide print-hide">{toolbar}</div> : null} 
   <div className="phide print-hide">{toolbar}</div>
   <motion.div
    exit={{
     opacity: 0,
    }}
    animate={{ opacity: 1 }}
    initial={{ opacity: 0 }}
    transition={{ type: "linear", duration: 1 }}
   >

     <div className="print-visible" style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 0 0", fontFamily: `${fon}` }}>
    <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}`, padding:0, marginBottom:0 }}>
    <IonCardContent style={{padding:0}}>
    <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${(Number(tsize)+8)}px` }}>
    {songName}
    </div>
    </IonCardContent>
   </IonCard>
   </div>

    <div style={{ backgroundColor: `${color}`, padding: "6px 0 4px 0", fontFamily: `${fon}`, marginTop: "0px", marginBottom: 0 }}>
     {!verses ? iarr2.map((sent, i) => {
      let ind1 = fun2.indexOf("Text", present3 + 4);
      present3 = ind1;
      let ind2 = i < iarr2.length - 1 ? fun2.indexOf("Text", ind1 + 4) : fun2.length;

      let zen = fun2.slice(ind1, ind2);

      let ztext = zen.split(/\r\n|\n/);

      left = false;

      

      return (
       <IonCard key={i} color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
        <IonCardContent>
         <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>Text {sent} </div>
         {ztext.map((vad, i) => {
          if (i === 0) return null;

          if (vad.indexOf(";") !== -1) {
           left = true;
          }

          if (!wwm && ztext[i - 1].indexOf(";") === -1 && vad.indexOf(";") !== -1) return null;
          if (!left) {
           return <div key={i} style={{ textAlign: "center", fontSize: `${tsize}px` }}>{vad}</div>;
          }

          if (left & (vad !== "")) {
           return (
            <div key={i}>
             <br />
             <div style={{ fontSize: `${tsize}px`, textAlign: "justify" }}>{vad}</div>
            </div>
           );
          }
          return null
         })}
        </IonCardContent>
       </IonCard>
      );
     }) : <>
     <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
        <IonCardContent>
        {verses.split("\n").map((cont, j)=>{
          return <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "center" }}>{cont}</div>
        })}
        </IonCardContent>
      </IonCard>
      <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
        <IonCardContent>
        <div style={{ fontSize: `${tsize}px`, textAlign: "center" }}>Translation</div>
        {translation.split("\n").map((cont,j)=>{
          return(cont ? <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "justify" }}><br />{cont}</div> : null)
        })}
        </IonCardContent>
      </IonCard>
     </> }
    </div>
   </motion.div>
   </IonContent>
   <Music 
   songName = {songName}
   hsongName = {""}
   songList = {content.chap[i2].song[id].link ?? (vname ? iskcon.songs[vindex].link : [{"linkname": "dummy", "linkaddress": "dummy", "hlinkname": "dummy" }])}
   songPath = {url}
   colorh={colorh}
   fon={fon}
   colori={colori}
   anchorEl={anchorEl}
   setAnchorEl={setAnchorEl}
   share_url={`https://vsnectar.web.app${url}`}
   vname = {content.chap[i2].song[id].vname}
   />
  </IonPage>
 );
}

export default SBP;
